/* eslint-disable immutable/no-mutation */

import { useAppContext } from '@contexts/app';
import { useEffect, useState } from 'react';
import { useAccess } from '@hooks/access';

export const useChat = () => {
  const {
    isLogged,
    admin: { isLogged: isAdminLogged },
  } = useAppContext();
  const access = useAccess();

  const [active, setActive] = useState(false);

  useEffect(() => {
    if (access.fieldUser || !isLogged || isAdminLogged || active) return;

    const script = document.createElement('script');
    script.id = 'hs-script-loader';
    script.src = '//js-na1.hs-scripts.com/49696952.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    setActive(true);
  }, [access.fieldUser, isLogged, isAdminLogged, active]);
};
